import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useUser } from "@clerk/clerk-react";
import { api } from "@/lib/api";
import type { GenerateResponse } from "@/types";

export interface ExtendVideoRequest {
  generation_id: string;
  prompt: string;
  duration_seconds?: number;
  name?: string;
  prompt_enhancer?: boolean;
  negative_prompt?: string;
  seed?: number;
  guidance_scale?: number;
  folder?: string;
}

// Start an extend video generation
export function useExtendVideo() {
  const { user } = useUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ExtendVideoRequest) => {
      if (!user?.id) throw new Error("No user ID");

      return api.post<GenerateResponse>("/extend-video", {
        ...params,
        user_id: user.id,
      });
    },
    onSuccess: () => {
      // Refresh user data to get updated credit balance
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
